import React, { Component } from 'react';

const disallowedPaths = [
	"/",
	"/retirement/?",
	"/retirement/v\\d/?",
	"/retirement/v\\d/contracts/?",
	"/retirement/v\\d/participants/?"
];

const occurrences = (needle, haystack) => {
	return (haystack.match(new RegExp(needle, "gi")) || []).length;
}

class TargetHost extends Component {

	constructor(props) {
		super(props);
		this.state = {
			targetHostError: false
		};
	}

	getVariableFromString = (str) => {
		if(str.includes("{")&&str.includes("}")){
			if(str==="{}"){
				return " ";
			}
			return str.substring(str.indexOf("{") + 1, str.indexOf("}"));
		}
		return false;
	};

	isValidHostname = (hostname) => {
  		const specialCharRegex = /[!@#$%^&*(),?"|<>]/gi;
  	   return specialCharRegex.test(hostname);
	};

	validateHost = (host) => {

		let match = disallowedPaths.find(r => host.match("^" + r + "$"));

		if(match){
			return host + " is incorrect.";
		}

		if(this.isValidHostname(host)){
			return host + " is invalid and has special characters.";
		}

		let openTags = occurrences("{", host);
		let closeTags = occurrences("}", host);
		if (openTags !== closeTags) {
			return "Unbalanced number of opening '{' and closing '}' tags on " + host;
		}

		let splitPath = host.split(".");
		let m =[];
		for (let i = 0; i < splitPath.length; i++) {
			let str = this.getVariableFromString(splitPath[i]);
			if(str){
				m.push(str);
			}
		}

		let regExAlphaNumeric = "^[0-9a-zA-Z]+$";
		if(m !=null ) {
			for (let i = 0; i < m.length; i++) {
				if (!m[i].match(regExAlphaNumeric)) {
					return "Incorrect host {" + m[i] + "}. Must be alphanumeric.";
				}
			}
		}

		let asterisk = occurrences("\\*", host);
		if(asterisk > 0) {
			return "* not allowed on " + host ;
		}

	}

	//lambda ensures correct 'this' scope
	onChange = (e) => {
		this.setState({
			targetHostError: false
		});
		let target = e.target.name;
		let value = e.target.value.replace(/\s/g, '');

		if(target === 'targetHost'){
			this.props.updateStore({
				[target]: value
			});
		}
	}

	isValidated() {

		let data = this.props.getStore();
		if(data.targetHost === null || data.targetHost === undefined || data.targetHost === ''  ){
			return false;
		}else{
			return true;
		}
	}

	render() {
		let data = this.props.getStore();
		let targetHostError = this.validateHost(data.targetHost);

		return <div>
			<div className="container">
				<br/>

				<div className="row">

					<div className="col-md-6">
						<h4>Target Host:</h4>
						<label htmlFor="targetHost" ></label>
						<p>The liberty domain is specific to your application. It can be internal or external URL with a proper format
						i.e. https://{"{liberty name}"}.{"{env}"}.theprincipal.net(.com)
						e.g. <strong>https://api.ecm.test.theprincipal.net/</strong></p>
						<input className="form-control" id="targetHost" name="targetHost" value={data.targetHost} onChange={this.onChange} />
						{targetHostError && <p className="alert alert-danger util-margin-top-10">{targetHostError}</p>}
					</div>
				</div>

			</div>
			<br/>
		</div>
	}
}


export default TargetHost;